import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";
import shortid from "shortid";
import { getPicklist, getSchoolById } from "../actions";
import { countryList } from "../../../../utils/constants";

class BeneficiaryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSchoolSubType: true,
    };
  }

  shouldComponentUpdate() {
    return true;
  }

  render() {
    const {
      form,
      errorMessage,
      objectInfo,
      onInputChanged,
      onBlurValidation,
      index: beneficiaryIndex,
      attachment,
      onFileUploaded,
      onRemoveFile,
    } = this.props;
    const { props } = this;
    const schoolList = Array.isArray(this.props.schoolList)
      ? this.props.schoolList.map((school) => ({
          value: school.Id,
          label: school.Name,
          subType: school.Partner_SubType__c,
        }))
      : [];
    const subTypeMap = {
      "Primary School": "Primary",
      "Secondary School": "Secondary",
      SPED: "SPED",
      ITE: "NITEC",
      Polytechnic: "Polytechnic",
      "Junior College": "JC",
      "Pri/Sec School": ["Primary", "Secondary"],
      "Sec/JC School": ["Secondary", "JC"],
    };
    let allCurrentLevel = [];
    const schoolNow = form.Current_School__c
      ? schoolList.filter((key) => key.value === form.Current_School__c)
      : null;
    if (form.Current_School__c) {
      allCurrentLevel = getPicklist(
        "Current_Level__c",
        objectInfo.Person__c,
        "object"
      );
      allCurrentLevel = allCurrentLevel.filter((obj) => {
        const typeCheck =
          subTypeMap[
            this.state.showSchoolSubType
              ? schoolNow[0].subType
              : form.schoolSubType
          ];
        if (typeof typeCheck === "string") {
          return obj.value.includes(typeCheck);
        }
        if (typeof typeCheck === "object") {
          const result = typeCheck.map((eachType) =>
            obj.value.includes(eachType)
          );
          return result.indexOf(true) > -1;
        }
        return false;
      });
      allCurrentLevel.push({ label: "", value: "" });
    }
    return (
      <div className="beneficiray-form">
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>
                Full Name in NRIC{" "}
                <small style={{ color: "red" }}>(required)</small>
              </label>
              <input
                onChange={onInputChanged}
                name={`Full_Name__c.${beneficiaryIndex}`}
                type="text"
                className={`form-control valid select ${
                  errorMessage.Full_Name__c ? "need-fix" : ""
                }`}
                value={form.Full_Name__c}
                required
              />
              <p className="error-message">{errorMessage.Full_Name__c}</p>
            </div>
          </div>
          <div className="col-sm-3">
            <label>
              ID Type <small className="red">(required)</small>
            </label>
            <input
              name={`ID_Type__c.${beneficiaryIndex}`}
              className="form-control"
              aria-invalid="false"
              value={form.ID_Type__c || "NRIC"}
              readOnly
              onChange={onInputChanged}
            />
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>
                NRIC/Birth Cert Number{" "}
                <small style={{ color: "red" }}>(required)</small>{" "}
              </label>
              <input
                onChange={onInputChanged}
                name={`ID_Number__c.${beneficiaryIndex}`}
                type="text"
                className={`form-control valid select ${
                  errorMessage.ID_Number__c ? "need-fix" : ""
                }`}
                value={form.ID_Number__c}
              />
              <p className="error-message">{errorMessage.ID_Number__c}</p>
            </div>
          </div>
          {/* Date of Birth */}
          <div className="col-sm-3">
            <div className="form-group">
              <label>
                Date of Birth <small style={{ color: "red" }}>(required)</small>
              </label>
              <DatePicker
                name={`Date_of_Birth__c.${beneficiaryIndex}`}
                dateFormat="DD/MM/YYYY"
                selected={
                  form.Date_of_Birth__c ? moment(form.Date_of_Birth__c) : null
                }
                className={`form-control fullw ${
                  errorMessage.Date_of_Birth__c ? "need-fix" : ""
                }`}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                maxDate={moment()}
                onChange={(val) =>
                  onInputChanged(val, "Date_of_Birth__c", beneficiaryIndex)
                }
              />
              <p className="error-message">{errorMessage.Date_of_Birth__c}</p>
            </div>
          </div>
        </div>
        ,
        <div className="row">
          {/* Gender */}
          {/* <div className="col-sm-3">
                        <div className="form-group">
                            <label>Gender <small style={{ color: 'red' }}>(required)</small></label>
                            <select
                                name={`Gender__c.${beneficiaryIndex}`}
                                onChange={onInputChanged}
                                className={`form-control select ${errorMessage.Gender__c ? 'need-fix' : ''}`}
                                value={form.Gender__c}
                                required
                            >
                                <option value="" />
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                        <p className="error-message">{errorMessage.Gender__c}</p>
                    </div> */}
          {/* Race */}
          {/* <div className="col-sm-3">
                        <div className="form-group">
                            <label>Race <small style={{ color: 'red' }}>(required)</small></label>
                            <select
                                name={`Race__c.${beneficiaryIndex}`}
                                onChange={(e) => {
                                    onInputChanged(e);
                                    if (e.target.value !== 'Others') onInputChanged('', 'Other_Race__c', beneficiaryIndex);
                                }}
                                className={`form-control select ${errorMessage.Race__c ? 'need-fix' : ''}`}
                                value={form.Race__c}
                            >
                                <option value="" />
                                {getPicklist('Race__c', objectInfo.Person__c)}
                            </select>
                            <p className="error-message">{errorMessage.Race__c}</p>
                        </div>
                    </div> */}
          {/* Other Race */}
          {/* <div className="col-sm-3">
                        <div className="form-group">
                            <label>Other Race</label>
                            <input
                                onChange={onInputChanged}
                                value={form.Other_Race__c}
                                name={`Other_Race__c.${beneficiaryIndex}`}
                                type="text"
                                className={`form-control ${errorMessage.Other_Race__c ? 'need-fix' : ''}`}
                                disabled={form.Race__c !== 'Others'}
                            />
                            <p className="error-message">{errorMessage.Other_Race__c}</p>
                        </div>
                    </div> */}
          {/* Nationality */}
          <div className="col-sm-3">
            <div className="form-group">
              <label>
                Nationality <small style={{ color: "red" }}>(required)</small>
              </label>
              <select
                name={`Nationality__c.${beneficiaryIndex}`}
                onChange={onInputChanged}
                className={`form-control ${
                  errorMessage.Nationality__c ? "need-fix" : ""
                }`}
                value={form.Nationality__c}
              >
                <option value="" />
                {getPicklist(
                  "Nationality__c",
                  objectInfo.Person__c,
                  "component",
                  ["Others"]
                )}
              </select>
              <p className="error-message">{errorMessage.Nationality__c}</p>
            </div>
          </div>
          {/* Current School */}
          <div className="col-sm-3">
            <div className="form-group">
              <label>
                School <small style={{ color: "red" }}>(required)</small>
              </label>
              <ReactSelect
                options={schoolList}
                className={`${
                  errorMessage.Current_School__c ? "need-fix" : ""
                }`}
                onChange={(val) => {
                  onInputChanged(
                    val.value,
                    "Current_School__c",
                    beneficiaryIndex
                  );
                  onInputChanged(
                    val.subType,
                    "schoolSubType",
                    beneficiaryIndex
                  );
                  onInputChanged("", "Current_Level__c", beneficiaryIndex);
                  this.setState({ showSchoolSubType: false });
                }}
                value={{
                  value: form.Current_School__c,
                  label: getSchoolById(schoolList, form.Current_School__c),
                }}
              />
              <p className="error-message">{errorMessage.Current_School__c}</p>
            </div>
          </div>
          {/* Current Level */}
          <div className="col-sm-3">
            <div className="form-group">
              <label>
                Current level <small style={{ color: "red" }}>(required)</small>
              </label>
              <ReactSelect
                options={allCurrentLevel}
                className={`${errorMessage.Current_Level__c ? "need-fix" : ""}`}
                onChange={(val) =>
                  onInputChanged(
                    val.value,
                    "Current_Level__c",
                    beneficiaryIndex
                  )
                }
                value={{
                  label: form.Current_Level__c,
                  value: form.Current_Level__c,
                }}
              />
              <p className="error-message">{errorMessage.Current_Level__c}</p>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>
                Email <small style={{ color: "red" }}>(required)</small>
              </label>
              <input
                type="email"
                className={`form-control select ${
                  errorMessage.Email_Address__c ? "need-fix" : ""
                }`}
                name={`Email_Address__c.${beneficiaryIndex}`}
                value={form.Email_Address__c}
                onChange={onInputChanged}
              />
              <p className="error-message">{errorMessage.Email_Address__c}</p>
            </div>
          </div>
        </div>
        <div className="row" key={`beneficiary.row03.${beneficiaryIndex}`}>
          {/* Other Nationality */}
          {/* <div className="col-sm-3">
                        <div className="form-group">
                            <label>Other Nationality</label>
                            <select
                                onChange={onInputChanged}
                                name={`Other_Nationality__c.${beneficiaryIndex}`}
                                className={`form-control ${errorMessage.Other_Nationality__c ? 'need-fix' : ''}`}
                                value={form.Other_Nationality__c}
                                disabled={form.Nationality__c !== 'Singaporean PR'}
                            >
                                <option value="" />
                                {countryList.filter(o => o !== 'Singapore')
                                    .map(country => <option key={shortid.generate()} value={country}>{country}</option>)}
                            </select>
                            <p className="error-message">{errorMessage.Other_Nationality__c}</p>
                        </div>
                    </div> */}

          {/* <div className="col-sm-3">
                        <div className="form-group">
                            <label>Stream</label>
                            <select
                                onChange={onInputChanged}
                                name={`Stream__c.${beneficiaryIndex}`}
                                value={form.Stream__c}
                                className={`form-control ${errorMessage.Stream__c ? 'need-fix' : ''}`}
                                disabled={form.schoolSubType !== 'Secondary School' || form.Current_Level__c.indexOf('Secondary') === -1}
                            >
                                <option value="" />
                                {getPicklist('Stream__c', objectInfo.Person__c)}
                            </select>
                        </div>
                    </div> */}
        </div>
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>Recommended Months of Payout</label>
              <br />
              <input
                onChange={(e)=>onInputChanged(e, "No_of_Receipts_Approved__c")}
                // onBlur={(e) => onBlurValidation(e, "No_of_Receipts_Approved__c")}
  //               onPaste={(e) => {
  //   const pastedText = e.clipboardData.getData('text');
  //   const pastedValue = Number(pastedText);
  //   if (pastedValue > 12 || isNaN(pastedValue)) {
  //     e.preventDefault(); // block the paste
  //     alert("Value must be a number between 0 and 12."); // or handle it another way
  //   }
  // }}
                name={`No_of_Receipts_Approved__c.${beneficiaryIndex}`}
                className={`form-control select ${
                  errorMessage.No_of_Receipts_Approved__c ? "need-fix" : ""
                }`}
                type="number"
                min="0"
                max={12}
                value={form.No_of_Receipts_Approved__c}
              />              
              <p className="error-message">
                {form && form.No_of_Receipts_Approved__c > 12 ? " Must be less than 12" : errorMessage.No_of_Receipts_Approved__c}
              </p>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>Recommended Start Date of Payout</label>
              <br />
              <DatePicker
                name={`Payout_Start__c.${beneficiaryIndex}`}
                dateFormat="DD/MM/YYYY"
                selected={
                  typeof form.Payout_Start__c === "string"
                    ? moment(form.Payout_Start__c)
                    : form.Payout_Start__c
                }
                className={`form-control fullw ${
                  errorMessage.Payout_Start__c ? "need-fix" : ""
                }`}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                minDate={moment("01-01-2010")}
                onChange={(val) =>
                  onInputChanged(val, "Payout_Start__c", beneficiaryIndex)
                }
              />
              <p className="error-message">{errorMessage.Payout_Start__c}</p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <div className="form-group">
              <label>Upload NRIC/FIN/Birth Certificate</label>
              <br />
              <label className="fileContainer">
                Choose File
                <input
                  onChange={onFileUploaded}
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                  type="file"
                  name={`NRIC.${beneficiaryIndex}`}
                  className="form-control-file"
                  aria-describedby="fh1"
                  accept=".jpeg,.jpg,.png,.pdf,image/jpeg,image/pjpeg,image/png,application/pdf"
                />
              </label>
              <p className="text">
                {attachment.NRIC ? attachment.NRIC.Name : null}
              </p>
              <br />
              <div className="text-center">
                {attachment.NRIC ? (
                  <a
                    href={null}
                    onClick={() => onRemoveFile("NRIC", beneficiaryIndex)}
                    className="btn btn-xs"
                  >
                    <i className="fa fa-times" />
                  </a>
                ) : null}
                <br />
              </div>
              <label>
                <small id="fileHelp1" className="form-text text-muted">
                  format: jpg, png, pdf only{" "}
                </small>
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BeneficiaryForm.propTypes = {
  form: PropTypes.object.isRequired,
  onInputChanged: PropTypes.func.isRequired,
  schoolList: PropTypes.array.isRequired,
  errorMessage: PropTypes.object.isRequired,
  objectInfo: PropTypes.object.isRequired,
  index: PropTypes.number,
  attachment: PropTypes.object.isRequired,
  onFileUploaded: PropTypes.func.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
};

BeneficiaryForm.defaultProps = {
  index: 0,
};
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = (state) => ({
  schoolList: state.salesforce.schoolList.fields,
});

export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/Tab3/BeneficiaryForm.js
// module id = 1015
// module chunks = 0